document.addEventListener("DOMContentLoaded", () => {

  // Fade-in animations
  const fadeElems = document.querySelectorAll(".ldh-fade");
  const slideElems = document.querySelectorAll(".ldh-slide");
  const popElems = document.querySelectorAll(".ldh-pop");

  function revealElements() {
    const trigger = window.innerHeight * 0.88;

    fadeElems.forEach(el => {
      const top = el.getBoundingClientRect().top;
      if (top < trigger) el.classList.add("visible");
    });

    slideElems.forEach(el => {
      const top = el.getBoundingClientRect().top;
      if (top < trigger) el.classList.add("visible");
    });

    popElems.forEach(el => {
      const top = el.getBoundingClientRect().top;
      if (top < trigger) el.classList.add("visible");
    });
  }

  revealElements();
  window.addEventListener("scroll", revealElements);


  // Smooth tier button hover lift
  document.querySelectorAll(".ldh-tier").forEach(card => {
    card.addEventListener("mouseenter", () => {
      card.classList.add("ldh-hover");
    });
    card.addEventListener("mouseleave", () => {
      card.classList.remove("ldh-hover");
    });
  });

});
